import React from 'react'
// import BTable from "../../common/checkboxTable";
import ATable from "../../common/table";



const  BulkAcceptDisputesTable = (props) => {
  const { tableData, loading, onRowClick, onTableChange, transactionGroups, acceptDeclineHandler, actionLoading, selectAll, selection, updateSelectAll, updateSelection, pageSize } = props;

  const toggleSelection = (key, status) => {
    if(status && status === "toggle-all") {
        if(selectAll === true) {
          updateSelectAll(false);
          updateSelection([])
          return 
        } else {
          let selection = []; 
          if(tableData && tableData.length) {
            tableData.forEach(data => {
              selection.push(data.logCode);
            })
          }
          updateSelectAll(true);
          updateSelection(selection)
          return 
        }
    } else {
      let selected = [...selection];
      const keyIndex = selected.indexOf(key);
      // const currentRow = document.getElementById(key);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        selected = [
          ...selected.slice(0, keyIndex),
          ...selected.slice(keyIndex + 1)
        ];
        // if(currentRow.checked === true) currentRow.checked = false;
      } else {
        // it does not exist so add it
        selected.push(key);
        // if(currentRow.checked === false) currentRow.checked = true;
      }
      // update the state
      updateSelection(selected)
    }
    
  };
 
  
  const columns = [
    {
      header: () => <div>
        <label>
        <input
          type="checkbox"
          onChange={() => toggleSelection(null, "toggle-all")}
        />
        <span
          className="lbl"
          checked={selectAll}
        >
          
        </span>
        </label>
      </div>,
      id: "checkbox",
      render: row => (<div>
        <label>
          <input
            type="checkbox"
            onChange={() => toggleSelection(row.row.logCode, null)}
            checked={selection.includes(row.row.logCode)}
          />
          <span
            className="lbl"
            defaultChecked={selection.includes(row.row.logCode)}
          >
          </span>
        </label>
    </div>),
      width: 35,
      sortable: false
    },
    // {
    //   header: "S/N",
    //   id: "s-n",
    //   render: row => <div>{paginatedCallBack(row.viewIndex)}</div>,
    //   width: 50
    // },
    {
      header: "Log Code",
      accessor: "logCode",
      width: 100
    },
    {
      header: "Issuer",
      accessor: "issuer",
      width: 130
    },
    {
      header: "Acquirer",
      accessor: "acquirer",
      width: 130
    },
    {
      header: "Customer Ref.",
      accessor: "customerReference",
      width: 130
    },
    // {
    //   header: "Merchant",
    //   accessor: "merchant",
    //   width: 130
    // },
    // {
    //   header: "Account Num.",
    //   accessor: "accountNumber",
    //   width: 130
    // },
    // {
    //   header: "PAN",
    //   accessor: "pan",
    //   width: 130
    // },
    {
      header: "Terminal Id",
      accessor: "Terminal Id",
      render: row => {
        return `${
          "Terminal Id" in row.row.additionalInfo ? row.row.additionalInfo["Terminal Id"]  : ""
        }`;
      },
      width: 130
    },

    {
      header: "STAN",
      accessor: "Stan",
      render: row => {
        return `${
          "Stan" in row.row.additionalInfo ? row.row.additionalInfo.Stan : ""
        }`;
      },
      width: 130
    },

    {
      header: "RRN",
      accessor: "Retrieval Reference Number",
      render: row => {
        return `${
          "Retrieval Reference Number" in row.row.additionalInfo ? row.row.additionalInfo["Retrieval Reference Number"]  : ""
        }`;
      },
      width: 130
    },

    {
      header: "Tran. Ref.",
      accessor: "transactionReference",
      width: 230
    },
    {
      header: "Tran. Date",
      accessor: "transactionDate"
    },
    {
      header: "Tran. Amount",
      accessor: "transactionAmount",
      render: row => {
        return `${row.row.transactionAmount}`;
      },
      width: 130
    },
    {
      header: "Category",
      accessor: "category"
    },
    {
      header: "Status",
      accessor: "status"
    },
    {
      header: "Created",
      accessor: "createdOn"
    },
    {
      header: "Status Expires",
      accessor: "statusScheduledEndDate"
    },
    {
      header: "Region",
      accessor: "region",
      width: 160
    }
  ]
    return (
      <div>
        <div className="row">
          <div className="col-md-8"></div>
          {transactionGroups.length && transactionGroups[0].actions.length && transactionGroups[0].actions.length === 1 ? <div className="col-md-2"></div> : ""}
        {
          transactionGroups.length && transactionGroups[0].actions.length && selection.length ? 
          transactionGroups[0].actions.map(action => (
              <div className="col-md-2">
                  <button
                    id="searchButton"
                    className="btn btn-primary btn-block"
                    onClick={()=>acceptDeclineHandler(action)}
                    disabled={actionLoading}
                  >
                    {actionLoading ? "..." : action}
                  </button>
              </div>
              
          )) : ""
          }
        </div>
        
        <br />
        <div>
          <ATable
            className="-striped -highlight"
            tableData={tableData}
            columns={columns}
            pageSize={pageSize}
            loading={loading}
            onRowClick={onRowClick}
            onChange={onTableChange || null}
            manual
            {...props}
          />
        </div>
      </div>
      
    );
  }

export default BulkAcceptDisputesTable;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulk_accept/BulkAcceptTable.js